/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-08-22 09:43:15
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-22 09:46:20
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface TransactionQueryListParams {
  current?: number
  size?: number
  insuranceCode?: any
  operateUser?: any
  orderSource?: any
  param?: any
  registrationTimeHead?: string
  registrationTimeTail?: string
  state?: any
  treatmentDoctorId?: number
  releasingTime?:any
  pageName?: any
}

export function transactionQueryList(
  params: TransactionQueryListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/transactionInfo`,
    method: 'GET',
    params,
  }
}

export interface TransactionQueryDetailListParams {
  current?: number
  size?: number
  billingCategory?: any
  registrationTimeHead?: string
  registrationTimeTail?: string
  param?: number
  state?: any
  treatmentDoctorId?: any
  releasingTime?:any
  pageName?: any
}

export function transactionDetailQueryList(
  params: TransactionQueryDetailListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/transactionDetailsInfo`,
    method: 'GET',
    params,
  }
}

export function transactionQueryTotal(
  params: TransactionQueryListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/transactionInfoSum`,
    method: 'GET',
    params,
  }
}

export function transactionDetailQueryTotal(
  params: TransactionQueryDetailListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/transactionDetailsInfoSum`,
    method: 'GET',
    params,
  }
}

// 导出
export function transactionDetailQueryExport(
  params: TransactionQueryDetailListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/transactionDetailsInfo/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

// 导出
export function transactionQueryExport(params: TransactionQueryListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/transactionInfo/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

export interface SubmitPageColumnListParams {
  pageName?: any
  configJson?: any
}

export function getSubmitPageColumnList(body: SubmitPageColumnListParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/tablefieldconfig/submit`,
    method: 'POST',
    body,
  }
}


export interface PageColumnListParams {
  pageName?: any
  id?: any
}

export function getPageColumnList(params: PageColumnListParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/tablefieldconfig/detail`,
    method: 'GET',
    params,
  }
}

